import React, { forwardRef } from 'react';
import { Button, Spinner, Text, Box } from 'grommet';
import { ButtonProps } from 'grommet/components/Button';

interface ExtendedProps extends ButtonProps {
  isLoading?: boolean;
}

type Props = ExtendedProps & JSX.IntrinsicElements['button'] & JSX.IntrinsicElements['a'];

const ButtonSpinner = forwardRef<HTMLButtonElement & HTMLAnchorElement, Props>(
  ({ isLoading, disabled, label, ...rest }: Props, ref): JSX.Element => (
    <Button
      {...rest}
      ref={ref}
      disabled={disabled || isLoading}
      label={
        isLoading ? (
          <Box direction='row' align='center' gap='small'>
            <Spinner color='white' size='xsmall' />
            <Text>{label}</Text>
          </Box>
        ) : (
          label
        )
      }
    />
  )
);

export default ButtonSpinner;
